<template>
    <!-- « ① Étape N »: the protocol page and the program tracking card share it. -->
    <div class="flex min-w-0 items-center gap-2.5">
        <span
            class="text-text-base flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-semibold"
            :class="badgeClass"
        >
            {{ index + 1 }}
        </span>
        <span class="truncate" :class="titleClass">{{ $t('metric.step') }} {{ index + 1 }}</span>
    </div>
</template>

<script setup>
defineProps({
    index: { type: Number, required: true },
    // The badge stands out from the background it sits on.
    badgeClass: { type: String, default: 'bg-dark-lighter' },
    titleClass: { type: String, default: 'text-text-darker' },
})
</script>
